// Helper to create consistent document titles from a list of strings.
// The title is built by concatenating the strings with a separator
// in between and appending "Picter".
export default function docTitle(...args: string[]) {
  const title = args.join(" - ");
  return `${title} - Picter`;
}
